import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import ThumbsUpDownIcon from '@material-ui/icons/ThumbsUpDown';
import PropTypes from 'prop-types';
import React from 'react';
import Information from '../../core/Information';
import { globalStyles as styles } from '../style/gstheme';
import { STATUS_PENDING } from '../utils/constants';
import withGS from '../withGShoc';

const suggestionFields = {
  deprecation: "There is a suggestion to deprecate this concept.",
  move: "There is a suggestion to move this concept to a different location in the hierarchy.",
  remove: "There is a suggestion to remove this concept from a location in the hierarchy."
};

class SuggestionManualInlineDisplay extends React.Component {

  render() {

    const { data, onShowSuggestion, id, problemName } = this.props;

    if (data.status && data.status[0] !== STATUS_PENDING) return null;

    return (
      <div>
        <Information
          margin={true}
          text={<span>
            <span data-test="problem-text">{suggestionFields[problemName]}</span>
            <Tooltip title="View suggestion detail">
              <span style={{ marginLeft: 6 }}>
                <IconButton data-test="view-detail" size="small" onClick={() => onShowSuggestion(id)}>
                  <ThumbsUpDownIcon fontSize="small" style={{ color: '#01579B' }} />
                </IconButton>
              </span>
            </Tooltip>
          </span>}
          dataTest="problematic-suggestion" />
      </div>
    );
  }
}

SuggestionManualInlineDisplay.propTypes = {
  classes: PropTypes.object,
  existingValues: PropTypes.object,
  problemName: PropTypes.string,
  onShowSuggestion: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  graph: PropTypes.string.isRequired
};

export default withStyles(styles)(withGS(SuggestionManualInlineDisplay, ["ALL"], null, {}, true));